import { Content01 } from './Content01';

export type { TypeContentProps } from './types';
export default Content01;
